import { render, staticRenderFns } from "./PushProduct.vue?vue&type=template&id=61785bc6"
import script from "./PushProduct.vue?vue&type=script&lang=js"
export * from "./PushProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports